<template>

  <div>
    <!--    Statisticas de Grupos e quantidade de usuarios no grupo -->
    <statistc-groups />
    <!-- Filters -->
    <users-list-filters
      :status-filter.sync="statusFilter"
      :status-options="statusOptions"
      @statusFilter="updatedStatusFilter"
    />

    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Buscar..."
              />

              <b-button
                v-if="$can('manage', 'all')"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-modal.modal-add-grupo
                variant="primary"
                class="ml-2"
              >

                <span class="text-nowrap">
                  <feather-icon
                    class="cursor-pointer"
                    icon="PlusIcon"
                    size="16"
                  />
                  Grupo
                </span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>

      <b-table
        ref="refGrupoListTable"
        class="position-relative"
        :items="fetchGrupos"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Nenhum registro encontrado"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: ID -->
        <template #cell(id)="data">
          <span class="text-nowrap text-primary text-bold">#{{ data.item.id }}</span>
        </template>

        <!-- Column: data_inclusao -->
        <template #cell(data_inclusao)="data">
          <span class="text-nowrap">{{ data.item.data_inclusao | formatDateTimeBr }}</span>
        </template>


        <!-- Column: Nome -->
        <template #cell(grupousuario)="data">

          <div class="text-nowrap">
            <feather-icon
                v-if="data.item.grupousuario"
                :icon="resolveUserRoleIcon(data.item.grupousuario)"
                size="18"
                class="mr-50"
                :class="`text-${resolveUserRoleVariant(data.item.grupousuario)}`"
            />
            <span class="align-text-top text-capitalize">{{ data.item.grupousuario }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(ativo)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserStatusVariant(data.item.ativo)}`"
            class="text-capitalize"
          >
            {{ data.item.ativo === 1 ? 'Ativo' : 'Inativo' }}
          </b-badge>
        </template>

        <template #head(actions)="data">
          <span style="display: flex;justify-content: end">{{ data.label }}</span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div
            class="row justify-content-end align-content-center"
            style="gap: 5px; flex-wrap: nowrap"
          >
            <feather-icon
              v-if="$can('manage', 'all')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Editar'"
              v-b-modal.modal-add-grupo
              style="color: var(--info);"
              size="20"
              class="icon-activity"
              icon="EditIcon"
              @click.stop="editarGrupo(data.item.id)"
            />
            <feather-icon
              v-if="$can('manage', 'all')"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.top="'Excluir'"
              v-b-modal.modal-confirme-delete-grupo
              size="20"
              style="color: var(--danger);"
              icon="TrashIcon"
              class="icon-activity"
              @click.stop="idGrupoUsuario = data.item.id"
            />
          </div>
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Mostrando {{ dataMeta.from }} para {{ dataMeta.to }} de {{
              dataMeta.of
            }} entradas</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalGrupoUsuario"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
    <ModalConfirm
      id-modal="modal-confirme-delete-grupo"
      title-modal="Excluir Grupo"
      label-btn-ok="Deletar"
      variant-label-btn-ok="danger"
      variant-label-btn-cancel="secondary"
      message="Deseja realmente excluir o grupo?"
      @ok="deletedGrupo"
    />
    <ModalAddGrupo
        @input="onChagenInput"
      v-model="blankGrupoData"
      @refetchData="refetchData"
    />
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable,
  BBadge, BPagination, VBModal, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import {
  ref, onMounted,
} from '@vue/composition-api'
import { avatarText, formatDateTimeBr } from '@core/utils/filter'
import { deletedGrupoUsuarioById } from '@/services/grupousuarioService'
import ModalConfirm from '@/components/ModalConfirm.vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import StatistcGroups from '@/components/usuarios/StatistcGroups.vue'
import UsersListFilters from './gruposListFilters.vue'
import useGrupoUsuarioList from './useGrupoUsuarioList'
import ModalAddGrupo from '../ModalAddGrupo.vue'

export default {
  components: {
    ModalAddGrupo,
    UsersListFilters,
    StatistcGroups,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BBadge,
    BPagination,
    ModalConfirm,
    vSelect,
  },
  directives: {
    'b-modal': VBModal,
    'b-tooltip': VBTooltip,
    Ripple,
  },
  filters: {
    formatDateTimeBr,
  },
  setup() {
    const toast = useToast()
    const idGrupoUsuario = ref(null)
    const gruposOptions = ref([])
    const isAddNewUserSidebarActive = ref(false)
    const USER_APP_STORE_MODULE_NAME = 'app-adm-grupousuario'
    const blankGrupoData = ref({
      id: null,
      grupousuario: '',
      ativo: 1,
      abilities: [],
    })

    onMounted(() => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchGrups`)
    })

    const updatedStatusFilter = e => {
      store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchGrups`)
    }

    const showAddEditUsuario = e => {
      isAddNewUserSidebarActive.value = e
    }

    const addGrupoUsuario = async () => {
      blankGrupoData.value = {
        id: null,
        grupousuario: '',
        ativo: 1,
        abilities: [],
      }
      isAddNewUserSidebarActive.value = true
    }

    const onChagenInput = e => {
      blankGrupoData.value = e
    }

    const editarGrupo = async id_grupo_usuario => {
      await store.dispatch(`${USER_APP_STORE_MODULE_NAME}/fetchGrupo`, { id: id_grupo_usuario })
        .then(data => {
          blankGrupoData.value = {
            id: data.data.id,
            grupousuario: data.data.grupousuario,
            ativo: data.data.ativo,
            abilities: data.data.abilities_grupousuario.map(item => item.ability.id),
          }
        })
    }

    const statusOptions = [
      { label: 'Todos', value: '' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]

    const {
      fetchGrupos,
      tableColumns,
      perPage,
      currentPage,
      totalGrupoUsuario,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
    } = useGrupoUsuarioList()

    const deletedGrupo = async () => {
      await deletedGrupoUsuarioById(idGrupoUsuario.value)
        .then(resp => {
          toast({
            component: ToastificationContent,
            props: {
              title: resp.message,
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          idGrupoUsuario.value = null
          refetchData()
        })
      refetchData()
    }
    return {
      onChagenInput,
      idGrupoUsuario,
      addGrupoUsuario,
      blankGrupoData,
      editarGrupo,
      showAddEditUsuario,
      gruposOptions,
      // Sidebar
      isAddNewUserSidebarActive,
      fetchGrupos,
      tableColumns,
      perPage,
      currentPage,
      totalGrupoUsuario,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refGrupoListTable,
      refetchData,

      // Filter
      avatarText,

      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      statusOptions,

      // Extra Filters
      roleFilter,
      grupoFilter,
      statusFilter,
      updatedStatusFilter,
      deletedGrupo,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.icon-activity {
  cursor: pointer;
  margin-left: 0.5rem;
}

.icon-activity:hover {
  color: var(--white) !important;
  background-color: var(--primary) !important;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
